import { LocaleObject } from "yup";

export type ValidationMessage = {
  key: string;
  values: object;
};

export const fromI18nKey = (key: string) => (values): ValidationMessage => ({ key, values });

export const messages: LocaleObject = {
  mixed: {
    default: fromI18nKey('validation.mixed.default'),
    required: fromI18nKey('validation.mixed.required'),
    defined: fromI18nKey('validation.mixed.defined'),
    notNull: fromI18nKey('validation.mixed.notNull'),
    oneOf: fromI18nKey('validation.mixed.oneOf'),
    notOneOf: fromI18nKey('validation.mixed.notOneOf'),
    notType: fromI18nKey('validation.mixed.notType'),
  },
  string: {
    length: fromI18nKey('validation.string.length'),
    min: fromI18nKey('validation.string.min'),
    max: fromI18nKey('validation.string.max'),
    matches: fromI18nKey('validation.string.matches'),
    email: fromI18nKey('validation.string.email'),
    url: fromI18nKey('validation.string.url'),
    uuid: fromI18nKey('validation.string.uuid'),
    trim: fromI18nKey('validation.string.trim'),
    lowercase: fromI18nKey('validation.string.lowercase'),
    uppercase: fromI18nKey('validation.string.uppercase')
  },
  number: {
    min: fromI18nKey('validation.number.min'),
    max: fromI18nKey('validation.number.max'),
    lessThan: fromI18nKey('validation.number.lessThan'),
    moreThan: fromI18nKey('validation.number.moreThan'),
    positive: fromI18nKey('validation.number.positive'),
    negative: fromI18nKey('validation.number.negative'),
    integer: fromI18nKey('validation.number.integer'),
  },
  date: {
    min: fromI18nKey('validation.date.min'),
    max: fromI18nKey('validation.date.max'),
  },
  object: {
    noUnknown: fromI18nKey('validation.object.noUnknown')
  },
  array: {
    min: fromI18nKey('validation.array.min'),
    max: fromI18nKey('validation.array.max'),
    length: fromI18nKey('validation.array.length'),
  },
  boolean: {
    isValue: fromI18nKey('validation.boolean.isValue'),
  }
}
